import React from 'react';
import filipinoSun from '../../assets/filipinosun.svg';

const BackgroundCharacter = ({ activeTab, isFullPage }) => {
    if (isFullPage) return null;

    return (
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 -translate-x-1/2 w-full h-full pointer-events-none z-[5] hidden lg:block" aria-hidden="true">
            <div key={activeTab} className="absolute top-1/2 left-[8%] w-[600px] h-[600px] lg:w-[800px] lg:h-[800px] 2xl:w-[1000px] 2xl:h-[1000px] -translate-x-1/2 -translate-y-1/2 animate-[charSlideIn_0.4s_ease-out_forwards] will-change-transform opacity-[0.15] md:opacity-[0.25] 2xl:opacity-[0.3]">
                <div className="absolute inset-0 w-full h-full animate-[floatGraphic_6s_ease-in-out_infinite] will-change-transform">
                    
                    <div className="w-full h-full animate-[spin_180s_linear_infinite]">

                        <img 
                            src={filipinoSun} 
                            alt="Background Filipino Sun" 
                            className="w-full h-full object-contain opacity-70"
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BackgroundCharacter;